import React from "react";

function DetailSaveStatus({ isSaving, hasChanges }) {
  if (isSaving) return <span style={{ fontSize: 12, color: "#6c757d" }}>Saving...</span>;
  if (hasChanges) return <span style={{ fontSize: 12, color: "#6c757d" }}>Unsaved changes</span>;
  return null;
}

export default DetailSaveStatus;
